/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Stack, Divider } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { map, set } from 'lodash';

/**
 * Internal dependencies
 */
import FormTextInput from 'components/forms/form-text-input';
import FormLabel from 'components/forms/form-label';
import FormSelect from 'components/forms/form-select';
import { requestConnectionTypes } from 'state/connection-types/actions';
import { getAllConnectionTypes } from 'state/connection-types/selectors';
import { saveConnection } from 'state/connections/actions';
import ConnectionInputRow from 'modules/dashboard/connections/connection-input-row';
import { getCurrentUsername } from 'state/current-user/selectors';

/**
 * Style dependencies
 */
import './styles.scss';

const CreateConnectionForm = ({ weblinkGroups, connectionTypes, ...props }) => {
	const [values, setValues] = useState({
		name: '',
		groupCode: '',
		connectionType: '',
		connectionDetails: {},
		enabled: false,
	});

	const [defaultconnectiontype, setDefaultConnectionType] = useState(null);

	useEffect(() => {
		try {
			props.requestConnectionTypes();
		} catch (error) {}
	}, []);

	const handleOnInputChange = (e) => {
		setValues(set({ ...values }, e.target.name, e.target.value));

		setDefaultConnectionType(e.target.value);
	};

	const connectionTypeOptions = [
		<option value='' key='default' />,
		...map(connectionTypes, ({ name, id, code }) =>
			(code != 'findit') && (code != 'shopify') ? (
				<option value={id} key={code}>
					{name}
				</option>
			) : (
				''
			),
		),
	];

	const chosenConnectionType = connectionTypes[values.connectionType];
	const chosenConnectionTypeFieldsMarkup =
		chosenConnectionType &&
		map(chosenConnectionType.default_connection_config, (v, k) => {
			return (
				<ConnectionInputRow
					key={k}
					k={k}
					connectionTypeCode={chosenConnectionType.code}
					label={v}
					prefix='connectionDetails.'
					value={values.connectionDetails[k]}
					handleOnChange={handleOnInputChange}
				/>
			);
		});

	const onSubmitForm = async (e) => {
		e.preventDefault();

		if (props.beforeSubmit) {
			props.beforeSubmit(values);
		}

		try {
			let response = await props.saveConnection(null, values);

			if (props.afterSuccessfullSubmit) {
				props.afterSuccessfullSubmit(response);
			}
		} catch (error) {
			console.log(error);
		}

		if (props.afterSubmit) {
			props.afterSubmit();
		}
	};

	return (
		<Box>
			<form id='create-connection-form' onSubmit={onSubmitForm}>
				<Stack space='large'>
					<Box>
						<FormLabel>Name:</FormLabel>
						<FormTextInput onChange={handleOnInputChange} name='name' value={values.name} />
					</Box>
					<Box>
						<FormLabel>Weblink Group Number:</FormLabel>
						<FormSelect onChange={handleOnInputChange} name='groupCode' value={values.groupCode}>
							<option value='' />
							{map(weblinkGroups, ({ name }) =>
							    (props.username.toUpperCase() == "GIF3122") ?
								name != '21' ? (
									<option value={name} key={name}>
										{`${name}`}
									</option>
								) : (
									''
								) : (name != '21') && (name != '24') ? (
									<option value={name} key={name}>
										{`${name}`} 
									</option>
								) : (
									''
								) ,
							)}
						</FormSelect>
					</Box>
					<Box>
						<FormLabel>Connection Type:</FormLabel>
						<FormSelect
							onChange={handleOnInputChange}
							name='connectionType'
							selected={values.connectionType}
							value={defaultconnectiontype}
						>
							{connectionTypeOptions}
						</FormSelect>
					</Box>
					<Divider />
					{chosenConnectionTypeFieldsMarkup}
				</Stack>
			</form>
		</Box>
	);
};

export default connect(
	(state) => ({
		connectionTypes: getAllConnectionTypes(state),
		username: getCurrentUsername(state),
	}),
	{
		requestConnectionTypes,
		saveConnection,
	},
)(CreateConnectionForm);
